<p-button label="Reserve supply" icon="pi pi-box" severity="secondary" [outlined]="true"
  (click)="open()"></p-button>

<p-dialog header="Reserve outbound supply" [(visible)]="visible" [modal]="true" [draggable]="false"
  [resizable]="false" [style]="{ width: 'min(980px, 96vw)' }" styleClass="supply-dialog">
  <div class="supply-layout">
    <aside class="supply-summary">
      <div class="summary-icon"><i class="pi pi-box"></i></div>
      <div><small>WAREHOUSE ALLOCATION</small><h3>{{ documentType }} #{{ documentId }}</h3>
        <p>On-hand stock is reserved now. Incoming transfer stock is promised until it is physically received.</p></div>
      <div class="summary-fact"><span>Active claims</span><strong>{{ activeClaimCount() }}</strong></div>
      <div class="summary-fact"><span>Stock posting</span><strong>Only at dispatch</strong></div>
    </aside>

    <div class="supply-content">
      @if (error) { <div class="supply-error" role="alert">{{ error }}</div> }
      @if (busy && !lines.length) { <p>Loading supply…</p> }
      @for (lineOption of lines; track lineOption.lineId) {
        <section class="supply-line">
          <div class="line-heading"><strong>{{ itemLabel(lineOption.itemId) }}</strong>
            <span>Remaining {{ lineOption.remainingQuantity | number:'1.0-4' }} base</span></div>
          @if (canManage() && lineOption.remainingQuantity > 0 && !preview) {
            @for (draft of drafts; track draft; let i = $index) {
              @if (draft.lineId === lineOption.lineId) {
                <div class="supply-fields">
                  <p-inputGroup>
                    <p-inputGroupAddon><i class="pi pi-map-marker"></i></p-inputGroupAddon>
                    <p-iftalabel>
                      <p-select [inputId]="'source-' + lineOption.lineId + '-' + i" [options]="sourceOptions(lineOption.lineId)"
                        optionLabel="label" optionValue="key" [(ngModel)]="draft.key" [filter]="true"
                        appendTo="body" styleClass="w-full" (onChange)="preview = undefined"></p-select>
                      <label [for]="'source-' + lineOption.lineId + '-' + i">Supply source</label>
                    </p-iftalabel>
                  </p-inputGroup>
                  <p-inputGroup>
                    <p-inputGroupAddon><i class="pi pi-hashtag"></i></p-inputGroupAddon>
                    <p-iftalabel>
                      <p-inputNumber [inputId]="'quantity-' + lineOption.lineId + '-' + i" [(ngModel)]="draft.quantity"
                        [min]="0" [maxFractionDigits]="4" [useGrouping]="false" styleClass="w-full"></p-inputNumber>
                      <label [for]="'quantity-' + lineOption.lineId + '-' + i">Base quantity</label>
                    </p-iftalabel>
                  </p-inputGroup>
                  <p-button icon="pi pi-trash" ariaLabel="Remove supply portion" severity="secondary" [text]="true"
                    (click)="remove(draft)"></p-button>
                </div>
              }
            }
            <div class="line-actions"><span>Selected {{ selectedTotal(lineOption.lineId) | number:'1.0-4' }} base</span>
              <p-button label="Add source" icon="pi pi-plus" severity="secondary" [text]="true"
                (click)="add(lineOption.lineId)"></p-button></div>
          }
        </section>
      }
      @if (claims.length) {
        <section class="supply-line"><h3>Incoming claims</h3>
          @if (hasActiveClaims()) {
            <p>Release active incoming claims before choosing replacement supply.</p>
          }
          @for (claim of claims; track claim.id) {
            <div class="claim-row"><div><strong>Transfer #{{ claim.sourceTransferId }}</strong>
              <span>Line #{{ claim.lineId }} · {{ claim.fulfilledQuantity }} / {{ claim.quantity }} base bound</span></div>
              <p-tag [value]="claim.status" [severity]="claim.status === 'SHORT' ? 'danger' : claim.status === 'BOUND' ? 'success' : 'info'"></p-tag>
              @if (canManage() && claim.status !== 'RELEASED') {
                <p-button label="Release" size="small" severity="secondary" [outlined]="true"
                  [disabled]="!releaseReason.trim() || busy" (click)="release(claim)"></p-button>
              }
            </div>
          }
          @if (canManage()) {
            <p-inputGroup class="release-reason"><p-inputGroupAddon><i class="pi pi-pencil"></i></p-inputGroupAddon>
              <p-iftalabel><input id="supplyReleaseReason" pInputText [(ngModel)]="releaseReason" class="w-full">
                <label for="supplyReleaseReason">Reason to release a claim</label></p-iftalabel></p-inputGroup>
          }
        </section>
      }
      @if (preview) {
        <section class="supply-line"><h3>Review allocation</h3>
          @for (entry of preview.summary; track entry) { <p>{{ entry }}</p> }
          <p-inputGroup><p-inputGroupAddon><i class="pi pi-pencil"></i></p-inputGroupAddon>
            <p-iftalabel><input id="supplyReason" pInputText [(ngModel)]="reason" class="w-full">
              <label for="supplyReason">Reason for reservation *</label></p-iftalabel></p-inputGroup>
        </section>
      }
    </div>
  </div>
  <ng-template pTemplate="footer"><div class="supply-footer">
    <p-button label="Close" severity="secondary" [outlined]="true" (click)="visible = false"></p-button>
    <span class="footer-spacer"></span>
    @if (preview) { <p-button label="Confirm reservation" icon="pi pi-check" [loading]="busy"
      [disabled]="!reason.trim() || busy" (click)="confirm()"></p-button> }
    @else if (canManage()) { <p-button label="Review supply" icon="pi pi-eye" [loading]="busy"
      [disabled]="!canReview() || busy" (click)="review()"></p-button> }
  </div></ng-template>
</p-dialog>
